import { render, staticRenderFns } from "./DropzoneOrChooseFile.vue?vue&type=template&id=ded30570"
import script from "./DropzoneOrChooseFile.vue?vue&type=script&lang=ts"
export * from "./DropzoneOrChooseFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports